import { render, staticRenderFns } from "./ship_company.vue?vue&type=template&id=0b73d774&scoped=true"
import script from "./ship_company.vue?vue&type=script&lang=js"
export * from "./ship_company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73d774",
  null
  
)

export default component.exports